import { motion } from 'framer-motion'
import { Link } from '@tanstack/react-router'
import type { SlideProps } from '@/components/SlideWizard'
import { useSlideCopy } from '@/lib/i18n'
import { copy } from './Slide8Wrapup.copy'

const ease = [0.16, 1, 0.3, 1] as const

export default function Slide8Wrapup(_props: SlideProps) {
  const c = useSlideCopy(copy)
  return (
    <div className="flex flex-col items-center text-center px-4 mx-auto max-w-3xl">
      <motion.h2
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.3, ease }}
        className="mt-4 text-5xl sm:text-7xl font-semibold text-slate-900 tracking-tight leading-[1.05] whitespace-pre-line"
      >
        {c.completionTitle}
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 0.7, ease }}
        className="mt-8 text-xl sm:text-2xl text-slate-500 leading-relaxed max-w-xl"
      >
        {c.body}
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 14 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6, delay: 1.3, ease }}
        className="mt-10"
      >
        <Link
          to="/basics/$basicsSlug"
          params={{ basicsSlug: 'pause-and-verify' }}
          className="inline-block rounded-full bg-violet-600 px-8 py-3.5 text-lg font-semibold text-white hover:bg-violet-700 transition-colors cursor-pointer"
        >
          {c.buttonLabel}
        </Link>
      </motion.div>
    </div>
  )
}
